import * as jstz from 'jstz';

export function getTimeZone(){
    return jstz.determine().name();
}